// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container .dashboard-header {
  margin-bottom: 20px;
}
.dashboard-container .dashboard-tabview {
  background: transparent;
  width: 100%;
}
.dashboard-container .dashboard-tabview .p-tabview-nav-content {
  width: 100%;
}
.dashboard-container .dashboard-tabview .p-tabview-nav-content .p-tabview-nav {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-width: 0 0 1px 0;
}
.dashboard-container .dashboard-tabview .p-tabview-nav-content .p-tabview-nav li .p-tabview-nav-link {
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  padding: 5px 20px;
  color: #666;
  transition: all 0.2s;
  outline: none;
  box-shadow: none;
  cursor: pointer;
}
.dashboard-container .dashboard-tabview .p-tabview-nav-content .p-tabview-nav li .p-tabview-nav-link:hover {
  color: #003da5;
}
.dashboard-container .dashboard-tabview .p-tabview-nav-content .p-tabview-nav li .p-tabview-nav-link:focus {
  outline: none;
  box-shadow: none;
}
.dashboard-container .dashboard-tabview .p-tabview-nav-content .p-tabview-nav li .p-tabview-title {
  font-size: 15px;
  line-height: 19.5px;
  color: #003da5;
  font-weight: 500;
  margin: 0;
}
.dashboard-container .dashboard-tabview .p-tabview-nav-content .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background: transparent;
  border-bottom: 2px solid #003da5;
  color: #003da5;
  font-weight: 600;
}
.dashboard-container .dashboard-tabview .p-tabview-nav-content .p-tabview-nav .p-tabview-ink-bar {
  display: none;
}
.dashboard-container .dashboard-tabview .p-tabview-panels {
  background: transparent;
  padding: 0px;
  margin-top: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/DashboardContainer.scss"],"names":[],"mappings":"AAEI;EACI,mBAAA;AADR;AAII;EACI,uBAAA;EACA,WAAA;AAFR;AAIQ;EACI,WAAA;AAFZ;AAIY;EACI,mBAAA;EACA,yBAAA;EACA,uBAAA;AAFhB;AAKoB;EACI,uBAAA;EACA,SAAA;EACA,oCAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAHxB;AAKwB;EACI,cAAA;AAH5B;AAMwB;EACI,aAAA;EACA,gBAAA;AAJ5B;AAQoB;EACI,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AANxB;AASoB;EACI,uBAAA;EACA,gCAAA;EACA,cAAA;EACA,gBAAA;AAPxB;AAWgB;EACI,aAAA;AATpB;AAcQ;EACI,uBAAA;EACA,YAAA;EACA,eAAA;AAZZ","sourcesContent":[".dashboard-container {\n\n    .dashboard-header {\n        margin-bottom: 20px;\n    }\n\n    .dashboard-tabview {\n        background: transparent;\n        width: 100%;\n\n        .p-tabview-nav-content {\n            width: 100%;\n\n            .p-tabview-nav {\n                background: #ffffff;\n                border: 1px solid #e5e7eb;\n                border-width: 0 0 1px 0;\n\n                li {\n                    .p-tabview-nav-link {\n                        background: transparent;\n                        border: 0;\n                        border-bottom: 2px solid transparent;\n                        border-radius: 0;\n                        padding: 5px 20px;\n                        color: #666;\n                        transition: all 0.2s;\n                        outline: none;\n                        box-shadow: none;\n                        cursor: pointer;\n\n                        &:hover {\n                            color: #003da5;\n                        }\n\n                        &:focus {\n                            outline: none;\n                            box-shadow: none;\n                        }\n                    }\n\n                    .p-tabview-title {\n                        font-size: 15px;\n                        line-height: 19.5px;\n                        color: #003da5;\n                        font-weight: 500;\n                        margin: 0;\n                    }\n\n                    &.p-highlight .p-tabview-nav-link {\n                        background: transparent;\n                        border-bottom: 2px solid #003da5;\n                        color: #003da5;\n                        font-weight: 600;\n                    }\n                }\n\n                .p-tabview-ink-bar {\n                    display: none;\n                }\n            }\n        }\n\n        .p-tabview-panels {\n            background: transparent;\n            padding: 0px;\n            margin-top: 0px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
